import {
  GetLateArrivalReportResponse,
  LateArrivalReportApiProps,
} from '../../../../types/TimeAndAttendance/LateArrivalReport/lateArrivalReportTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import { lateArrivalReportApiConfig, AllowedHttpMethods } from '../../apiList'

const getEmployeeLateComings = async (
  props: LateArrivalReportApiProps,
): Promise<GetLateArrivalReportResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: lateArrivalReportApiConfig.getEmployeeLateComings,
    method: AllowedHttpMethods.get,
    params: {
      employeeId: props.employeeId,
      month: props.month,
      year: props.year,
      startIndex: props.startIndex,
      endIndex: props.endIndex,
      country: props.country,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const lateArrivalReportApi = {
  getEmployeeLateComings,
}
export default lateArrivalReportApi
